export const DASHBOARD = '/dashboard',
    FEEDBACK_CYCLE_OVERVIEW = '/feedback-cycles',
    FEEDBACK_CYCLE_EDIT_NEW = '/feedback-cycles/new-edit/:cycleId',
    FEEDBACK_NO_CYCLE = '/feedback/no-cycle',
    FEEDBACK_OVERVIEW = '/feedback/company',
    FEEDBACK_OVERVIEW_WITH_CYCLE = '/feedback/company/:cycleId?tab',
    FEEDBACK_PERSONAL_CYCLE = '/feedback-cycles/personal',
    FEEDBACK_PROVIDE_PREVIEW = '/feedback/provide/:cycleId/preview',
    FEEDBACK_TEMPLATE_OVERVIEW = '/feedback/template',
    MEETING_DASHBOARD = '/meetings-dashboard',
    OBJECTIVE_CYCLE_OVERVIEW = '/objective-cycles',
    OBJECTIVE_BROWSER = '/objective-browser',
    OBJECTIVE_NO_CYCLE = '/objectives/no-cycle',
    OBJECTIVE_OVERVIEW = '/objectives/company',
    OBJECTIVE_OVERVIEW_WITH_CYCLE = '/objectives/company/:cycleId',
    OBJECTIVE_TEAM = '/objectives/team/:managerId',
    REVIEW_CYCLE_OVERVIEW = '/review-cycles',
    REVIEW_GRAPH_COMPANY = '/reviews/graph/company',
    REVIEW_GRAPH_TEAM = '/reviews/graph/team/:managerId',
    REVIEW_NO_CYCLE = '/reviews/no-cycle',
    REVIEW_OVERVIEW = '/reviews/company',
    REVIEW_OVERVIEW_WITH_CYCLE = '/reviews/company/:cycleId',
    REVIEW_TEAM_WITH_CYCLE = '/reviews/team/:managerId/:cycleId',
    ADMIN_REVIEWS_SETTINGS = '/admin/reviews/settings',
    USER_DIRECTORY = '/users',
    USER_CREATE = '/users/create',
    YOUR_COMPANY_USER_CREATE = '/company/directory/create',
    YOUR_COMPANY_FEEDBACK_PERSONAL_CYCLE_OLDER = '/company/feedback-personal',
    YOUR_COMPANY_FEEDBACK_PERSONAL_CYCLE = '/company/feedback/personal',
    YOUR_TEAM_FEEDBACK_PERSONAL_CYCLE = '/team/feedback/personal',
    MESSAGE_STREAM = '/messages',
    OLD_SAMPLE_CONTENT_MGMT = '/vacuumSampleCompany',
    ADMIN_PLATFORMS = '/admin/platforms',
    ADMIN_PLATFORMS_EDIT = '/admin/platforms/edit',
    ADMIN_COMPANY_BASICS = '/admin/basics',
    NEW_USER_PROFILE = '/user-new/:id',
    OLD_USER_PROFILE = '/user-old/:id',
    OLD_ADMIN_EMAIL_MANAGE = '/admin/email/manage',
    ENGAGEMENT_SYSTEM = '/engagement/system',
    ADMIN_BAMBOO = '/admin/bamboo',
    ADMIN_BAMBOO_HISTORY = '/admin/bamboo/history',
    ADMIN_BAMBOO_PREVIEW = '/admin/bamboo/preview',
    ADMIN_BAMBOO_CONFIG = '/admin/bamboo/config',
    ADMIN_GOOGLE_APPS_IMPORT = '/admin/google-apps/:selectedTab?',
    ADMIN_SLACK_CONFIGURATION = '/admin/slack',
    ADMIN_NAMELY = '/admin/namely',
    ADMIN_NAMELY_HISTORY = '/admin/namely/history',
    ADMIN_NAMELY_PREVIEW = '/admin/namely/preview',
    ADMIN_NAMELY_CONFIG = '/admin/namely/config',
    ADMIN_PERSONIO = '/admin/personio',
    ADMIN_PERSONIO_HISTORY = '/admin/personio/history',
    ADMIN_PERSONIO_PREVIEW = '/admin/personio/preview',
    ADMIN_PERSONIO_CONFIG = '/admin/personio/config',
    ADMIN_SAPLING = '/admin/sapling',
    ADMIN_SAPLING_HISTORY = '/admin/sapling/history',
    ADMIN_SAPLING_PREVIEW = '/admin/sapling/preview',
    ADMIN_SAPLING_CONFIG = '/admin/sapling/config',
    ADMIN_CALENDAR_INTEGRATION = '/admin/calendar-integration',
    ADMIN_SAML = '/admin/saml',
    ADMIN_BADGES = '/admin/badges',
    INTEGRATIONS_SAPLING = '/integrations/sapling',
    INTEGRATIONS_SAPLING_HISTORY = '/integrations/sapling/history',
    INTEGRATIONS_SAPLING_PREVIEW = '/integrations/sapling/preview',
    INTEGRATIONS_SAPLING_CONFIG = '/integrations/sapling/config',
    FEEDBACK_CYCLE_CREATE_NEW = '/feedback-cycles/new-create',
    FEEDBACK_CYCLE_COPY_NEW = '/feedback-cycles/new-copy/:cycleId',
    OBJECTIVE_CYCLE_CREATE = '/objective-cycles/create',
    OBJECTIVE_CYCLE_EDIT = '/objective-cycles/edit/:cycleId',
    OBJECTIVE_CYCLE_COPY = '/objective-cycles/copy/:cycleId',
    REVIEW_CYCLE_CREATE = '/review-cycles/create',
    REVIEW_CYCLE_COPY = '/review-cycles/copy/:cycleId',
    YOUR_COMPANY_FEEDBACK_REQUESTED = '/company/requested-feedback',
    YOUR_COMPANY_FEEDBACK_REQUESTED_TEMPLATES = '/company/requested-feedback/templates',
    YOUR_COMPANY_FEEDBACK_REQUESTED_SETTINGS = '/company/requested-feedback/settings',
    YOUR_COMPANY_MEETINGS_INSIGHTS = '/company/meetings/insights',
    YOUR_COMPANY_MEETINGS_SETTINGS = '/company/meetings/settings',
    YOUR_COMPANY_MEETINGS_TEMPLATES = '/company/meetings/templates',
    YOUR_COMPANY_MEETINGS_TEMPLATES_CREATE = '/company/meetings/templates/create',
    YOUR_COMPANY_MEETINGS_TEMPLATES_EDIT = '/company/meetings/templates/:templateId',
    YOUR_COMPANY_PRAISE = '/company/praise',
    YOUR_COMPANY_MEETINGS = '/company/meetings',
    YOUR_COMPANY_MEETINGS_SHARED = '/company/meetings/shared',
    YOUR_COMPANY_MEETINGS_SHARED_PAGE = '/company/meetings/shared/:userIds',
    YOUR_COMPANY_MEETINGS_SHARED_DEDICATED = '/company/meetings/shared/meeting/:meetingId',
    YOUR_COMPANY_MEETINGS_MY_TEMPLATES = '/company/meetings/my-templates',
    YOUR_COMPANY_MEETINGS_MY_TEMPLATES_CREATE = '/company/meetings/my-templates/create',
    YOUR_COMPANY_MEETINGS_MY_TEMPLATES_EDIT = '/company/meetings/my-templates/:templateId',
    SURVEYS_CREATE = '/survey-admin/create',
    SURVEYS_EDIT = '/survey-admin/edit/:surveyId',
    SURVEYS_COPY = '/survey-admin/copy/:surveyId',
    ADMIN_V2_MEETINGS = '/v2/admin/meetings',
    ADMIN_V2_MEETINGS_INSIGHTS = '/v2/admin/meetings/insights',
    ADMIN_V2_MEETINGS_SETTINGS = '/v2/admin/meetings/settings',
    ADMIN_V2_MEETINGS_TEMPLATES = '/v2/admin/meetings/templates',
    ADMIN_V2_MEETINGS_TEMPLATES_CREATE = '/v2/admin/meetings/templates/create',
    ADMIN_V2_MEETINGS_TEMPLATES_EDIT = '/v2/admin/meetings/templates/:templateId',
    ADMIN_V2_PRAISE = '/v2/admin/praise',
    ADMIN_V2_SURVEYS = '/v2/admin/surveys',
    ADMIN_V2_SURVEYS_WITH_SURVEY = '/v2/admin/surveys/:surveyId',
    ADMIN_V2_SURVEYS_WITH_SURVEY_PRINT = '/v2/admin/surveys/:surveyId/print',
    ADMIN_V2_SURVEYS_CREATE = '/v2/admin/surveys/create',
    ADMIN_V2_SURVEYS_EDIT = '/v2/admin/surveys/edit/:surveyId',
    ADMIN_V2_SURVEYS_COPY = '/v2/admin/surveys/copy/:surveyId',
    ADMIN_V2_OBJECTIVES_SELECT_CYCLE = '/v2/admin/objectives',
    ADMIN_V2_OBJECTIVES_CYCLE_OVERVIEW = '/v2/admin/objectives/:cycleId',
    ADMIN_V2_OBJECTIVE_CYCLE_CREATE = '/v2/admin/objectives/create',
    ADMIN_V2_OBJECTIVE_CYCLE_EDIT = '/v2/admin/objectives/edit/:cycleId',
    ADMIN_V2_OBJECTIVE_CYCLE_COPY = '/v2/admin/objectives/copy/:cycleId',
    ADMIN_V2_FEEDBACK_SELECT_CYCLE = '/v2/admin/feedback',
    ADMIN_V2_FEEDBACK_WITH_CYCLE = '/v2/admin/feedback/:cycleId',
    ADMIN_V2_FEEDBACK_CYCLE_CREATE = '/v2/admin/feedback/create',
    ADMIN_V2_FEEDBACK_CYCLE_EDIT = '/v2/admin/feedback/edit/:cycleId',
    ADMIN_V2_FEEDBACK_CYCLE_COPY = '/v2/admin/feedback/copy/:cycleId',
    ADMIN_V2_FEEDBACK_TEMPLATES = '/v2/admin/feedback/templates',
    ADMIN_FEEDBACK_SETTINGS = '/admin/feedback/settings',
    ADMIN_V2_FEEDBACK_REQUESTED = '/v2/admin/feedback-requests',
    ADMIN_V2_FEEDBACK_REQUESTED_TEMPLATES = '/v2/admin/feedback-requests/templates',
    ADMIN_V2_FEEDBACK_REQUESTED_SETTINGS = '/v2/admin/feedback-requests/settings',
    ADMIN_V2_REVIEWS_SELECT_CYCLE = '/v2/admin/reviews',
    ADMIN_V2_REVIEWS_QUESTIONNAIRES = '/v2/admin/reviews/questionnaires',
    ADMIN_V2_REVIEWS_WITH_CYCLE = '/v2/admin/reviews/:cycleId',
    ADMIN_V2_REVIEW_CYCLE_CREATE = '/v2/admin/reviews/create',
    ADMIN_V2_REVIEW_CYCLE_EDIT = '/v2/admin/reviews/edit/:cycleId',
    ADMIN_V2_REVIEW_CYCLE_COPY = '/v2/admin/reviews/copy/:cycleId',
    ADMIN_V2_REVIEW_GRAPH_WITH_CYCLE = '/v2/admin/reviews/graph/:cycleId',
    ADMIN_V2_USERS_DIRECTORY = '/v2/admin/directory',
    ADMIN_V2_USERS_DIRECTORY_CREATE = '/v2/admin/directory?create',
    ADMIN_V2_MESSAGES = '/v2/admin/messages',
    ADMIN_V2_DASHBOARD = '/v2/admin/home',
    ADMIN_V2_AUTOMATIONS = '/v2/admin/automations',
    ADMIN_OVERVIEW = '/admin',
    ADMIN_FEATURE_SELECTION = '/admin/feature-selection',
    ADMIN_REPORT_EMAILS = '/admin/email-reports',
    ADMIN_MAIL_LOG = '/admin/mail-log/:companyId?',
    ADMIN_BOUNCED_EMAILS = '/admin/bounced-emails',
    ADMIN_MESSAGE_STATISTICS = '/admin/message-statistics/:companyId?',
    ADMIN_MERGE_USERS = '/admin/merge-users/:sourceUserId?',
    ADMIN_OBJECTIVE_CATEGORIES = '/admin/objective/categories',
    ADMIN_OBJECTIVE_RATINGS = '/admin/objective/ratings',
    ADMIN_OBJECTIVES_SETTINGS = '/admin/objectives/settings',
    ADMIN_PAYMENT_DETAILS = '/admin/payment-details',
    ADMIN_BILLING = '/admin/billing',
    ADMIN_BILLING_CHECKOUT = '/admin/checkout',
    ADMIN_BILLING_CHECKOUT_STEP = '/admin/checkout/:defaultStep',
    ADMIN_CSV_IMPORT = '/admin/csv/:selectedTab?',
    ADMIN_EMAIL_MANAGE = '/admin/emails',
    ADMIN_HELPFUL_RESOURCES = '/admin/helpful-resources',
    ADMIN_SAMPLE_CONTENT = '/admin/sample-content',
    ADMIN_SAMPLE_CONTENT_PROGRESS = '/admin/sample-content-progress/:mode?',
    ADMIN_HIP_CHAT = '/admin/hip-chat',
    ADMIN_DESIGN = '/admin/design',
    ADMIN_DATETIME = '/admin/datetime',
    ADMIN_SETTINGS_DATETIME = '/admin/settings/datetime',
    ADMIN_CUSTOM_WORDING = '/admin/custom-wording',
    INTEGRATIONS = '/integrations',
    INTEGRATIONS_BAMBOO = '/integrations/bamboo',
    INTEGRATIONS_BAMBOO_HISTORY = '/integrations/bamboo/history',
    INTEGRATIONS_BAMBOO_PREVIEW = '/integrations/bamboo/preview',
    INTEGRATIONS_BAMBOO_CONFIG = '/integrations/bamboo/config',
    INTEGRATIONS_GOOGLE_APPS_IMPORT = '/integrations/google-apps/:selectedTab?',
    INTEGRATIONS_ADMIN_GOOGLE_APPS_IMPORT = '/admin/integrations/google-apps/:selectedTab?',
    INTEGRATIONS_SLACK_CONFIGURATION = '/integrations/slack',
    INTEGRATIONS_NAMELY = '/integrations/namely',
    INTEGRATIONS_NAMELY_HISTORY = '/integrations/namely/history',
    INTEGRATIONS_NAMELY_PREVIEW = '/integrations/namely/preview',
    INTEGRATIONS_NAMELY_CONFIG = '/integrations/namely/config',
    INTEGRATIONS_PERSONIO = '/integrations/personio',
    INTEGRATIONS_PERSONIO_HISTORY = '/integrations/personio/history',
    INTEGRATIONS_PERSONIO_PREVIEW = '/integrations/personio/preview',
    INTEGRATIONS_PERSONIO_CONFIG = '/integrations/personio/config',
    INTEGRATIONS_KALLIDUS = '/integrations/kallidus',
    INTEGRATIONS_KALLIDUS_HISTORY = '/integrations/kallidus/history',
    INTEGRATIONS_KALLIDUS_PREVIEW = '/integrations/kallidus/preview',
    INTEGRATIONS_KALLIDUS_CONFIG = '/integrations/kallidus/config',
    INTEGRATIONS_CALENDAR_INTEGRATION = '/integrations/calendar-integration',
    INTEGRATIONS_SAML = '/integrations/saml',
    INTEGRATIONS_WORKDAY = '/integrations/workday',
    INTEGRATIONS_WORKDAY_HISTORY = '/integrations/workday/history',
    INTEGRATIONS_WORKDAY_PREVIEW = '/integrations/workday/preview',
    INTEGRATIONS_WORKDAY_CONFIG = '/integrations/workday/config',
    INTEGRATIONS_SFTP = '/integrations/sftp',
    INTEGRATIONS_SFTP_HISTORY = '/integrations/sftp/history',
    INTEGRATIONS_SFTP_CONFIG = '/integrations/sftp/config',
    RETENTION = '/retention',
    ADMIN_RETENTION = '/admin/retention',
    INSIGHTS = '/insights',
    ADMIN_ADVANCED = '/admin/advanced',
    ADMIN_USERSETTINGS = '/admin/usersettings',
    YOUR_SURVEYS_WITH_SURVEY = '/surveys/:surveyInstanceId',
    REVIEW_CYCLE_EDIT = '/review-cycles/edit/:cycleId',
    REVIEW_GRAPH_COMPANY_WITH_CYCLE = '/reviews/graph/company/:cycleId',
    YOUR_TEAM = '/team',
    YOUR_TEAM_FEEDBACK_SELECT_CYCLE = '/team/feedback',
    YOUR_TEAM_FEEDBACK_REQUESTED = '/team/requested-feedback',
    YOUR_TEAM_FEEDBACK_WITH_CYCLE = '/team/feedback/:managerId/:cycleId',
    YOUR_TEAM_MEETINGS = '/team/meetings',
    YOUR_TEAM_OBJECTIVES_OVERVIEW = '/team/objectives/:managerId/:cycleId',
    YOUR_TEAM_OBJECTIVES = '/team/objectives',
    YOUR_TEAM_OBJECTIVES_LIST = '/team/objectives/list',
    YOUR_TEAM_OBJECTIVES_BROWSER = '/team/objectives/browse',
    YOUR_TEAM_OBJECTIVES_SELECT_CYCLE = '/team/objectives/cycles',
    YOUR_TEAM_ACTIVITY = '/team/activity',
    YOUR_TEAM_REVIEWS_SELECT_CYCLE = '/team/reviews',
    YOUR_TEAM_REVIEWS_WITH_CYCLE = '/team/reviews/:managerId/:cycleId',
    YOUR_TEAM_USERS = '/team/people',
    YOUR_TEAM_USERS_USER = '/team/people/:userId',
    YOUR_COMPANY = '/company',
    YOUR_COMPANY_OBJECTIVES = '/company/objectives',
    YOUR_COMPANY_OBJECTIVES_LIST = '/company/objectives/list',
    YOUR_COMPANY_OBJECTIVES_BROWSER = '/company/objectives/browse',
    YOUR_COMPANY_OBJECTIVES_HIERARCHY = '/company/objectives/hierarchy',
    YOUR_COMPANY_OBJECTIVES_CASCADE = '/company/objectives/cascade',
    YOUR_COMPANY_ACTIVITY = '/company/activity',
    YOUR_COMPANY_MESSAGES = '/company/messages',
    YOUR_COMPANY_FEEDBACK_SELECT_CYCLE = '/company/feedback',
    YOUR_COMPANY_FEEDBACK_WITH_CYCLE = '/company/feedback/:cycleId',
    YOUR_COMPANY_OBJECTIVES_SELECT_CYCLE = '/company/objectives/cycles',
    YOUR_COMPANY_OBJECTIVES_OVERVIEW = '/company/objectives/cycles/:cycleId',
    YOUR_COMPANY_REVIEWS_SELECT_CYCLE = '/company/reviews',
    YOUR_COMPANY_REVIEWS_WITH_CYCLE = '/company/reviews/:cycleId',
    YOUR_COMPANY_REVIEWS_QUESTIONNAIRES = '/company/reviews/questionnaires',
    YOUR_COMPANY_SURVEYS = '/company/surveys',
    YOUR_COMPANY_SURVEYS_WITH_SURVEY = '/company/surveys/:surveyId',
    YOUR_COMPANY_SURVEYS_WITH_SURVEY_PRINT = '/company/surveys/:surveyId/print',
    YOUR_COMPANY_USERS = '/company/directory',
    YOUR_COMPANY_USERS_CREATE = '/company/directory?create',
    SETTINGS_CYCLE_FEEDBACK = '/settings/cycle-feedback',
    SETTINGS_ANYTIME_FEEDBACK = '/settings/anytime-feedback',
    SETTINGS_REVIEWS = '/settings/reviews';
